import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import GallerySection from '../components/GallerySection';
import ContactForm from '../components/ContactForm';

const SERVICES = [
  {
    title: 'Stålkonstruktioner',
    description: 'Skræddersyede stålkonstruktioner til industri, erhverv og private byggeprojekter.',
    url: '/staalkonstruktioner',
    image: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/staalspaer-lejligheder-11024x576-2d10694eef-106-1000x563.jpg',
    icon: 'fa-solid fa-industry'
  },
  {
    title: 'Rækværk',
    description: 'Elegante og sikre rækværk i stål, glas og træ, tilpasset ejendommens arkitektur.',
    url: '/raekvaerk',
    image: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/raekvaerk-valby-station1024x768-0ae2c60169-150-1000x750.jpg',
    icon: 'fa-solid fa-shield-halved'
  },
  {
    title: 'Trapper',
    description: 'Indendørs og udendørs trappeløsninger af højeste håndværksmæssige kvalitet.',
    url: '/trapper',
    image: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/haveje-trappe-og-vaern-7-330-1000x750.jpg',
    icon: 'fa-solid fa-stairs'
  },
  {
    title: 'Porte',
    description: 'Skræddersyede, stilfulde porte og skydeporte i stål og træ.',
    url: '/porte',
    image: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/skydeport1024x768-eabe017ad6-154-1000x750.jpg',
    icon: 'fa-solid fa-door-closed'
  },
  {
    title: 'Hegn',
    description: 'Solide og skræddersyede hegn i træ, stål, jern og aluminium.',
    url: '/hegn',
    image: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/hegn-vinkelvej800x600-afc2859fa0-94.jpg',
    icon: 'fa-solid fa-border-all'
  },
  {
    title: 'Altan',
    description: 'Specialfremstillede altaner tilpasset kundens unikke ønsker og behov.',
    url: '/altan',
    image: 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/altan-med-glas-11024x768-911f0a0581-58-1000x750.jpg',
    icon: 'fa-solid fa-house-chimney-window'
  }
];

export default function HomePage() {
  return (
    <>
      <SEOHead
        title="Smed i Gribskov i Nordsjælland | Gribskovsmeden ApS"
        description="Professionel smed på Nordsjælland – vi specialiserer os i alt fra altaner og trapper til porte og stålkonstruktioner. Kontakt os i dag"
      />

      {/* Hero Section */}
      <section className="relative bg-stone-950 text-white overflow-hidden py-28 sm:py-36 lg:py-48 min-h-[580px] lg:min-h-[680px] flex items-center">
        <div className="absolute inset-0 z-0 opacity-55">
          <img
            src="https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/staalspaer-lejligheder-11024x576-2d10694eef-106-1000x563.jpg"
            alt="Gribskovsmeden Værksted og Stålkonstruktioner"
            className="w-full h-full object-cover object-center"
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-950/80 via-stone-950/50 to-stone-950/20" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-3xl mx-auto flex flex-col items-center">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 text-xs font-semibold uppercase tracking-wider mb-6">
              <i className="fa-solid fa-hammer" aria-hidden="true"></i>
              <span>Smed i Gribskov i Nordsjælland</span>
            </div>

            <h1 className="text-3xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold tracking-tight text-white leading-[1.1]">
              Smed i Gribskov i Nordsjælland
            </h1>

            <p className="mt-6 text-lg sm:text-xl text-stone-300 leading-relaxed font-normal">
              Vi er et ordreproducerende smedefirma. Vi producerer til virksomheder og private.
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/kontakt"
                className="px-7 py-3.5 bg-amber-600 hover:bg-amber-500 text-white font-bold text-sm rounded-lg shadow-lg shadow-amber-900/30 transition-all flex items-center gap-2"
              >
                <span>Kontakt os i dag</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
              </Link>
              <Link
                to="/kontakt"
                className="px-7 py-3.5 bg-stone-800/90 hover:bg-stone-700 text-stone-200 hover:text-white font-semibold text-sm rounded-lg border border-stone-700 transition-all flex items-center gap-2"
              >
                <span>Få et godt tilbud</span>
              </Link>
            </div>

            {/* Quick stats/contact ribbon */}
            <div className="mt-12 pt-8 border-t border-stone-800/80 w-full grid grid-cols-1 sm:grid-cols-3 gap-6 text-left">
              <div className="flex items-center justify-center sm:justify-start gap-3.5">
                <div className="w-10 h-10 rounded-lg bg-stone-800 flex items-center justify-center text-amber-500 shrink-0">
                  <i className="fa-solid fa-phone" aria-hidden="true"></i>
                </div>
                <div>
                  <div className="text-xs text-stone-400">Ring direkte</div>
                  <a href="tel:+4548796816" className="text-sm font-bold text-white hover:text-amber-400 whitespace-nowrap">
                    +45 48 79 68 16
                  </a>
                </div>
              </div>

              <div className="flex items-center justify-center sm:justify-start gap-3.5">
                <div className="w-10 h-10 rounded-lg bg-stone-800 flex items-center justify-center text-amber-500 shrink-0">
                  <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                </div>
                <div>
                  <div className="text-xs text-stone-400">Værksted & Kontor</div>
                  <div className="text-sm font-semibold text-stone-200">Helsinge, Nordsjælland</div>
                </div>
              </div>

              <div className="flex items-center justify-center sm:justify-start gap-3.5">
                <div className="w-10 h-10 rounded-lg bg-stone-800 flex items-center justify-center text-amber-500 shrink-0">
                  <i className="fa-solid fa-award" aria-hidden="true"></i>
                </div>
                <div>
                  <div className="text-xs text-stone-400">Erfaring</div>
                  <div className="text-sm font-semibold text-stone-200">Mere end 10 års erfaring</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="py-16 md:py-24 bg-stone-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <span className="text-amber-600 font-bold uppercase tracking-wider text-xs">
              Specialister i smedearbejde
            </span>
            <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
              Vores primære arbejdsområder
            </h2>
            <p className="mt-4 text-base text-stone-600">
              Vi leverer skræddersyede smedeløsninger i stål, aluminium og rustfrit stål til private og erhverv.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {SERVICES.map((srv) => (
              <Link
                key={srv.title}
                to={srv.url}
                className="bg-white rounded-2xl overflow-hidden border border-stone-200/90 shadow-sm hover:shadow-md transition-shadow flex flex-col group block"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-stone-900">
                  <img
                    src={srv.image}
                    alt={srv.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300 block"
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                    loading="lazy"
                  />
                </div>

                <div className="p-6 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-stone-900 group-hover:text-amber-600 transition-colors">
                      {srv.title}
                    </h3>
                    <p className="mt-2.5 text-sm text-stone-600 leading-relaxed">
                      {srv.description}
                    </p>
                  </div>

                  <div className="mt-6 pt-4 border-t border-stone-100 flex items-center justify-between">
                    <span className="text-sm font-bold text-stone-900 group-hover:text-amber-600 transition-colors flex items-center gap-2">
                      <span>Læs mere om {srv.title.toLowerCase()}</span>
                      <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Presentation / About Section */}
      <section className="py-16 md:py-24 bg-white border-y border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
            {/* Left Content */}
            <div className="lg:col-span-7 space-y-6 flex flex-col justify-between">
              <div>
                <span className="text-amber-600 font-bold uppercase tracking-wider text-xs">
                  Gribskovsmeden ApS
                </span>
                <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-extrabold text-stone-900 tracking-tight">
                  Smed i Nordsjælland med mange års erfaring
                </h2>
              </div>

              <div className="prose prose-stone max-w-none text-stone-700 leading-relaxed space-y-4">
                <p>
                  Leder du efter en smed i Nordsjælland? Gribskovsmeden ApS, som er placeret i Nordsjælland, har grundlag på mere end 10 års konstant, positiv udvikling og erfaring som smed. Gennem årene har vi betjent en lang række gode, professionelle kunder, som er kommet igen og igen. Der er samlet en masse erfaring op på vejen, men vi er stadig ‘unge’ og fyldt med gå-på-mod.
                </p>
                <p>
                  Gribskovsmeden ApS ejes og drives af Lars Baundal, som startede firmaet tilbage i 2010. Firmaet har været i udvikling siden og vokset til medarbejderstab på 10 mand, som har stor erfaringer med smedearbejde, her iblandt aluminium og rustfri stål.
                </p>
              </div>

              <div className="pt-4 border-t border-stone-200">
                <h3 className="text-lg font-bold text-stone-900 mb-2">
                  Kontakt os og hør mere om os som smed i Nordsjælland
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed">
                  Søger du efter en smed i Nordsjælland eller har du spørgsmål er du altid velkommen til at udfylde vores{' '}
                  <Link to="/kontakt" className="text-amber-600 font-semibold underline hover:text-amber-700">
                    kontaktformular
                  </Link>
                  , ringe til os på{' '}
                  <a href="tel:48796816" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">
                    (+45) 48 79 68 16
                  </a>{' '}
                  /{' '}
                  <a href="tel:61604241" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">
                    (+45) 61 60 42 41
                  </a>{' '}
                  eller skrive en mail til{' '}
                  <a href="mailto:lars@gribskovsmeden.dk" className="font-semibold text-stone-900 hover:text-amber-600 whitespace-nowrap">
                    lars@gribskovsmeden.dk
                  </a>
                  , så kan vi tage den derfra.
                </p>
              </div>
            </div>

            {/* Right Images & Highlight */}
            <div className="lg:col-span-5 flex items-stretch">
              <div className="relative rounded-2xl overflow-hidden shadow-lg border border-stone-200 bg-stone-900 w-full min-h-[380px] h-full">
                <img
                  src="https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/hegn-vinkelvej800x600-afc2859fa0-94_c03f1a4a.jpg"
                  alt="Hegn udført af Gribskovsmeden"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                  style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision & Virksomheden */}
      <section className="py-16 md:py-20 bg-stone-900 text-stone-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-14">
            {/* Mission og vision */}
            <div className="bg-stone-800/80 border border-stone-700/80 rounded-2xl p-8 lg:p-10 space-y-4">
              <div className="w-12 h-12 rounded-xl bg-amber-500/10 text-amber-400 flex items-center justify-center text-2xl mb-2">
                <i className="fa-solid fa-bullseye" aria-hidden="true"></i>
              </div>
              <h3 className="text-2xl font-bold text-white tracking-tight">
                Mission og vision
              </h3>
              <p className="text-stone-300 leading-relaxed text-sm">
                Gribskovsmeden ApS er et ordreproducerende smedefirma, der producerer til store og små virksomheder inden for nybyggeri og renovering. Vi arbejder målrettet på at levere kvalitetsarbejde til konkurrencedygtige priser, og bestræber os på at indfri, kunders forventninger, og overholde aftalte betingelser og leveringstider.
              </p>
              <p className="text-stone-300 leading-relaxed text-sm">
                Vores vision er enkel: Vi vil give dig det bedste produkt. Det vigtigste for os er, at du får maksimalt udbytte af vores sparring og er fuldt tilfreds med hele processen fra første samtale til det endelige resultat. Kvalitet er nøgleordet, og vi sætter en stor ære i at levere professionelle ydelser til vores kunder.
              </p>
            </div>

            {/* Virksomheden */}
            <div className="bg-stone-800/80 border border-stone-700/80 rounded-2xl p-8 lg:p-10 space-y-4 flex flex-col justify-between">
              <div className="space-y-4">
                <div className="w-12 h-12 rounded-xl bg-amber-500/10 text-amber-400 flex items-center justify-center text-2xl mb-2">
                  <i className="fa-solid fa-building-shield" aria-hidden="true"></i>
                </div>
                <h3 className="text-2xl font-bold text-white tracking-tight">
                  Virksomheden
                </h3>
                <p className="text-stone-300 leading-relaxed text-sm">
                  Det stærkeste fundament for vores virksomhed er vores yderst engagerede og kompetente medarbejderstab, der dagligt laver kvalitetsarbejde. Vi har valgt at undlade at angive priser på vores ydelser her på hjemmesiden, da prisen er meget afhængig af opgavens type, størrelse og kompleksibilitet. Hvis du ønsker hjælp til din næste opgave, er du meget velkommen til at kontakte din smed i Nordsjælland.
                </p>
              </div>

              <div className="pt-6">
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-amber-600 hover:bg-amber-500 text-white font-bold text-sm rounded-lg transition-colors"
                >
                  <span>Kontakt Gribskovsmeden</span>
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section Teaser */}
      <GallerySection
        title="Galleri"
        subtitle="Her kan du se eksempler på det arbejde vi har udført for vores kunder"
        showFilter={true}
        limit={6}
      />

      <div className="text-center pb-16">
        <Link
          to="/galleri"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-stone-900 hover:bg-stone-800 text-white font-bold text-sm rounded-lg shadow-sm transition-all"
        >
          <span>Se hele vores galleri</span>
          <i className="fa-solid fa-images" aria-hidden="true"></i>
        </Link>
      </div>

      {/* Contact Section - Restyled to Design Reference */}
      <section className="bg-stone-950 text-stone-100 relative overflow-hidden border-t border-stone-800">
        {/* Top visual image band */}
        <div className="relative h-48 sm:h-56 w-full overflow-hidden">
          <img
            src="https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/staalspaer-lejligheder-11024x576-2d10694eef-106-1000x563.jpg"
            alt="Smedeværksted Gribskovsmeden"
            className="w-full h-full object-cover object-center opacity-20"
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-stone-950/40 via-stone-950/80 to-stone-950"></div>
        </div>

        {/* Top band: 4-column grid of overlapping floating cards */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 -mt-20 sm:-mt-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {/* Card 1: Adresse */}
            <div className="bg-white text-stone-900 rounded-2xl p-6 sm:p-7 text-center shadow-xl border border-stone-200/90 flex flex-col items-center justify-center transition-transform hover:-translate-y-1">
              <div className="w-14 h-14 lg:w-20 lg:h-20 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mb-3 sm:mb-4 text-2xl lg:text-4xl shadow-inner transition-all">
                <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
              </div>
              <span className="text-xs font-extrabold uppercase tracking-widest text-amber-600 mb-1">
                Adresse
              </span>
              <a
                href="https://www.google.com/maps/place/Rundinsvej%2045,%203200%20Helsinge"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-semibold text-stone-800 hover:text-amber-600 transition-colors"
              >
                Rundinsvej 45, 3200 Helsinge
              </a>
            </div>

            {/* Card 2: Telefon */}
            <div className="bg-white text-stone-900 rounded-2xl p-6 sm:p-7 text-center shadow-xl border border-stone-200/90 flex flex-col items-center justify-center transition-transform hover:-translate-y-1">
              <div className="w-14 h-14 lg:w-20 lg:h-20 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mb-3 sm:mb-4 text-2xl lg:text-4xl shadow-inner transition-all">
                <i className="fa-solid fa-phone" aria-hidden="true"></i>
              </div>
              <span className="text-xs font-extrabold uppercase tracking-widest text-amber-600 mb-1">
                Telefon
              </span>
              <div className="flex flex-col text-sm font-semibold text-stone-800">
                <a href="tel:+4548796816" className="hover:text-amber-600 transition-colors whitespace-nowrap">
                  +45 48 79 68 16
                </a>
                <a href="tel:61604241" className="text-xs text-stone-500 font-normal hover:text-amber-600 transition-colors whitespace-nowrap mt-0.5">
                  Mobil: (+45) 61 60 42 41
                </a>
              </div>
            </div>

            {/* Card 3: E-mail */}
            <div className="bg-white text-stone-900 rounded-2xl p-6 sm:p-7 text-center shadow-xl border border-stone-200/90 flex flex-col items-center justify-center transition-transform hover:-translate-y-1">
              <div className="w-14 h-14 lg:w-20 lg:h-20 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mb-3 sm:mb-4 text-2xl lg:text-4xl shadow-inner transition-all">
                <i className="fa-solid fa-envelope" aria-hidden="true"></i>
              </div>
              <span className="text-xs font-extrabold uppercase tracking-widest text-amber-600 mb-1">
                E-mail
              </span>
              <a
                href="mailto:lars@gribskovsmeden.dk"
                className="text-sm font-semibold text-stone-800 hover:text-amber-600 transition-colors whitespace-nowrap"
              >
                lars@gribskovsmeden.dk
              </a>
            </div>

            {/* Card 4: CVR / Kvalitet */}
            <div className="bg-white text-stone-900 rounded-2xl p-6 sm:p-7 text-center shadow-xl border border-stone-200/90 flex flex-col items-center justify-center transition-transform hover:-translate-y-1">
              <div className="w-14 h-14 lg:w-20 lg:h-20 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mb-3 sm:mb-4 text-2xl lg:text-4xl shadow-inner transition-all">
                <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
              </div>
              <span className="text-xs font-extrabold uppercase tracking-widest text-amber-600 mb-1">
                CVR & Garanti
              </span>
              <span className="text-sm font-semibold text-stone-800">
                CVR: 32660681
              </span>
              <span className="text-xs text-stone-500 mt-0.5">
                Kvalitetssmedearbejde
              </span>
            </div>
          </div>
        </div>

        {/* Bottom band: Split 2-column layout */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20 sm:pb-28">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            {/* Left column: Vertical form with underline borders & pill button */}
            <div className="lg:col-span-6">
              <div className="mb-6">
                <span className="text-amber-400 font-bold uppercase tracking-wider text-xs">
                  Skriv til os
                </span>
                <h3 className="text-2xl sm:text-3xl font-bold text-white mt-1">
                  Udfyld formularen for et uforpligtende tilbud
                </h3>
              </div>
              <ContactForm variant="underline" />
            </div>

            {/* Right column: Heading, italicized lead text, body text, social icons */}
            <div className="lg:col-span-6 space-y-6 text-stone-300">
              <div>
                <span className="text-amber-500 font-bold uppercase tracking-wider text-xs">
                  Tag kontakt i dag
                </span>
                <h2 className="mt-2 text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                  Har du brug for hjælp til en smedeopgave?
                </h2>
              </div>

              <p className="text-lg italic font-bold text-amber-400 leading-relaxed border-l-2 border-amber-500/60 pl-4 py-1">
                “Da vi er et firma som har stor fokus på vores kunder og god service, så kan du altid kontakte os. Vi står parat til at hjælpe.”
              </p>

              <div className="space-y-4 text-stone-300 text-sm sm:text-base leading-relaxed">
                <p>
                  Gribskovsmeden leverer skræddersyede smedeløsninger i højeste kvalitet til både private og erhverv i hele Nordsjælland og Storkøbenhavn.
                </p>
                <p>
                  Uanset om det gælder stålkonstruktioner, specialdesignede rækværk, trapper, altaner eller porte, rådgiver vi dig professionelt fra første idé til færdig montage.
                </p>
              </div>

              <div className="pt-6 border-t border-stone-800">
                <span className="text-xs uppercase tracking-wider font-semibold text-stone-400 block mb-3">
                  Direkte kontaktveje:
                </span>
                <div className="flex items-center gap-3">
                  <a
                    href="tel:+4548796816"
                    className="w-11 h-11 rounded-full bg-stone-900 border border-stone-800 text-amber-400 hover:bg-amber-500 hover:text-white flex items-center justify-center transition-colors shadow-md"
                    aria-label="Ring på telefon +45 48 79 68 16"
                  >
                    <i className="fa-solid fa-phone text-sm" aria-hidden="true"></i>
                  </a>
                  <a
                    href="mailto:lars@gribskovsmeden.dk"
                    className="w-11 h-11 rounded-full bg-stone-900 border border-stone-800 text-amber-400 hover:bg-amber-500 hover:text-white flex items-center justify-center transition-colors shadow-md"
                    aria-label="Send mail til lars@gribskovsmeden.dk"
                  >
                    <i className="fa-solid fa-envelope text-sm" aria-hidden="true"></i>
                  </a>
                  <a
                    href="https://www.google.com/maps/place/Rundinsvej%2045,%203200%20Helsinge"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-full bg-stone-900 border border-stone-800 text-amber-400 hover:bg-amber-500 hover:text-white flex items-center justify-center transition-colors shadow-md"
                    aria-label="Find vej på kort"
                  >
                    <i className="fa-solid fa-location-dot text-sm" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
